import { DriversTableColumn } from './tableColumns';

export enum DriverActionType {
  SET_DRIVERS_TABLE_COLUMNS = `SET_DRIVERS_TABLE_COLUMNS`,
}

export interface SetDriversTableColumnsAction {
  type: DriverActionType.SET_DRIVERS_TABLE_COLUMNS;
  payload: Array<DriversTableColumn>;
}

export type DriverActions = SetDriversTableColumnsAction;
